"use client";

import { motion } from "framer-motion";
import { Compass, UserCheck, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 18
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export default function OtherServices() {
  return <section id="weitere-services" data-nav="light" className="bg-background text-foreground py-20 md:py-24 border-b border-border">
      <div className="max-w-[1136px] mx-auto px-6">
        {/* Header Block */}
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-wider font-semibold text-primary mb-2">
            Weitere Services
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-bold tracking-tight text-foreground">
            Mehr von Hurghada entdecken
          </h2>

          {/* Signature Hairline Rule with Terminal Dot */}
          <div className="relative mt-5 mb-12 flex items-center" aria-hidden="true">
            <div className="h-px bg-border w-28 md:w-36" />
            <div className="size-2 rounded-full bg-primary -ml-1 ring-2 ring-background" />
          </div>
        </div>

        {/* Two Service Cards */}
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1: Ausflüge ab Hurghada */}
          <motion.div variants={itemVariants}>
            <Card className="h-full border border-border bg-card rounded-md shadow-2xs hover:border-primary/40 hover:shadow-xs transition-[border-color,box-shadow] duration-200 flex flex-col justify-between">
              <div>
                <CardHeader className="p-6 pb-3">
                  <div className="size-11 rounded-md bg-primary/10 border border-primary/25 flex items-center justify-center text-primary shrink-0 mb-4">
                    <Compass className="size-5" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl font-semibold tracking-tight text-foreground">
                    Ausflüge ab Hurghada
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-6 pt-0">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Sightseeing-Ausflüge ab Hurghada, zum Beispiel eine Tour nach Luxor; Umfang und Preis stimmst du vorab mit uns ab.
                  </p>
                </CardContent>
              </div>

              <div className="p-6 pt-0 mt-2">
                <Button asChild variant="outline" className="w-full sm:w-auto font-medium">
                  <Link to="/ToursExcursionsDEPage" className="inline-flex items-center gap-2">
                    Ausflüge ansehen
                    <ArrowRight className="size-4" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </Card>
          </motion.div>

          {/* Card 2: Privaten Fahrer mieten */}
          <motion.div variants={itemVariants}>
            <Card className="h-full border border-border bg-card rounded-md shadow-2xs hover:border-primary/40 hover:shadow-xs transition-[border-color,box-shadow] duration-200 flex flex-col justify-between">
              <div>
                <CardHeader className="p-6 pb-3">
                  <div className="size-11 rounded-md bg-primary/10 border border-primary/25 flex items-center justify-center text-primary shrink-0 mb-4">
                    <UserCheck className="size-5" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl font-semibold tracking-tight text-foreground">
                    Privaten Fahrer mieten
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-6 pt-0">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Privates Fahrzeug mit Fahrer für 2, 4, 6 oder 8 Stunden; Route, Zwischenstopps und Preis werden vorab bestätigt.
                  </p>
                </CardContent>
              </div>

              <div className="p-6 pt-0 mt-2">
                <Button asChild variant="outline" className="w-full sm:w-auto font-medium">
                  <Link to="/PrivateDriverHireDEPage" className="inline-flex items-center gap-2">
                    Privaten Fahrer anfragen
                    <ArrowRight className="size-4" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}